export const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname.includes("new-dev") ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export const isOnlyLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export const isReleaseEnvironment = Boolean(
  window.location.hostname.includes("new-rls")
);

export default isLocalhost ? "dev" : "prd";

// Endpoint do WebSocket por ambiente. O ID da API muda a cada recriação da
// WebSocket API no AWS — manter sincronizado com `serverless info -s <stage>`.
const WS_ENDPOINTS: Record<string, string> = {
  dev: "wss://fznocdko1l.execute-api.us-east-1.amazonaws.com/dev",
  prd: "wss://1zf2f8cc5m.execute-api.us-east-1.amazonaws.com/prd",
};

export const wsEndpoint = WS_ENDPOINTS[isLocalhost ? "dev" : "prd"];
